import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getConsolidationSummaryTermometroStudentsDetail(params): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/termometro/financeiro/historico_aluno/', {params});
  return data;
}

type QueryFnType = typeof getConsolidationSummaryTermometroStudentsDetail;

function useConsolidationSummaryTermometroStudentsDetail(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-summary-termometro-students-detail', params],
    queryFn: () => getConsolidationSummaryTermometroStudentsDetail(params),
  });
}

export { getConsolidationSummaryTermometroStudentsDetail, useConsolidationSummaryTermometroStudentsDetail };
